import React, { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { useHistory, useRouteMatch } from 'react-router-dom'
import { useFeature } from '@cbgms/base/feature-flags'
import { createWorkorder } from 'app/workorder/state/workorder/actions'
import { POSTWorkorderResponse } from '@cbgms/api'
import { useIsPortal } from 'utils/Subscription/PermissionSelector'

const stripTailingSlash = (url: string) => {
  if (url.endsWith('/')) return url.slice(0, url.length - 1)
  return url
}

export const buildProductGroupURL = (matchUrl: string, ID: string, orderID?: string) => {
  const base = matchUrl.match(/.*product-groups/i)

  if (base) {
    return `${base[0]}/${ID}`
  }

  if (matchUrl === '/' && orderID) {
    return `/orders/${orderID}/product-groups/${ID}`
  }

  return `${stripTailingSlash(matchUrl)}/product-groups/${ID}`
}

export const useGotoProductGroup = () => {
  const match = useRouteMatch()
  const history = useHistory()
  const dispatch = useDispatch()
  const isPortal = useIsPortal()
  const splitProductSearchEnabled = useFeature('axnl-split-product-search')

  return useCallback(
    (_: React.SyntheticEvent, searcher: any) => {
      if (!searcher?.ID) {
        // clearing the input causes an empty value to come in
        return
      }

      if (splitProductSearchEnabled && isPortal && match.url === '/') {
        dispatch(createWorkorder({}))
          .then((result: POSTWorkorderResponse) => {
            const orderUUID = result.Data.UUID
            history.push(buildProductGroupURL(match.url, searcher.ID, orderUUID))
          })
          .catch(() => {
            history.push(buildProductGroupURL(match.url, searcher.ID))
          })
      } else {
        history.push(buildProductGroupURL(match.url, searcher.ID))
      }
    },
    [match.url, splitProductSearchEnabled, history, dispatch]
  )
}
